// Utilities for generating DOM-safe element IDs from location/media owner names.

export const toDomSafeId = (value: string) => {
  const cleaned = value
    .trim()
    // Replace anything not safe for DOM ids (spaces, punctuation, non-latin) with underscores.
    .replace(/[^A-Za-z0-9_-]/g, "_")
    .replace(/_{2,}/g, "_")
    .replace(/^_+|_+$/g, "");

  return cleaned || "item";
};

export const getLocationFileInputId = (locationName: string) => `fileInput-${toDomSafeId(locationName)}`;

export const getMediaOwnerFileInputId = (mediaOwnerName: string) => `fileInput-${toDomSafeId(mediaOwnerName)}`;

export const getCustomMaterialFileInputId = (locationName: string) =>
  `custom-file-input-${toDomSafeId(locationName)}`;
